// extracted by mini-css-extract-plugin
export var activeFilterButton = "_p9-c";
export var backButton = "_p9-4";
export var backIcon = "_p9-5";
export var chevronShortcut = "_p9-6";
export var container = "_p9-1";
export var editor = "_p9-8";
export var editorWrapper = "_p9-7";
export var prefix = "_p9-2";
export var searchIcon = "_p9-3";
export var suffix = "_p9-9";
export var suffixContent = "_p9-a";
export var suffixText = "_p9-b";
export var wrapper = "_p9-0";